import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type FindPathStudentsParams = {
  pathId: number;
  filters: Record<string, any>;
};

const { useFind: usePathStudents } = getCRUDHooks({
  entityName: 'pathStudent',
  find: ({ pathId, filters }: FindPathStudentsParams) =>
    clientApi.getOCClient().helpers.learningContent.paths.id(pathId).students.find(filters),
});

// eslint-disable-next-line import/prefer-default-export
export { usePathStudents };
